module.exports = __webpack_public_path__ + "static/we_can_create_custom_templates-0e02404d3b3e59a52bd7c113e38bc2b5.png";